import { temAcesso } from '@/shared/auth/temAcesso'

const Parametros = () => import('./Parametros.vue')

export default {
    path: 'parametros',
    name: 'Parametros',
    component: Parametros,
    beforeEnter: (to, from, next) => {
        if (temAcesso('ADMIN-PARAMETROS-00')) {
            next()
        }
    }
}
